<template>
  <section class="world-background">
    <cards-roulette
      :options="options"
      :withImages="false"
      :numerated="false"
      :loop="false"
      :type="'has_account_auditor'"
    />
  </section>
</template>

<script>
import FormQuestions from '@/constants/form_questions.js'
import CardsRoulette from '@/components/on-board/CardsRoulette.vue'
import enumeratesFormater from '@/mixins/enumeratesFormater.js'
import OnBoardStepMixin from '@/mixins/onBoardStepMixin.js'


export default {
  components: { CardsRoulette },
  mixins: [enumeratesFormater, OnBoardStepMixin],
  data() {
    return {
      options: []
    }
  },
  mounted() {
    this.options = this.tableDataToListFormat(FormQuestions.hasAccountAuditor)
  }
}
</script>
